import React, { Component } from 'react'
import { connect } from 'react-redux'

import './_counter.css'

class Counter extends Component {
  static defaultProps = {
    num: 0
  }

  pluralForm = (count, one, two, five) => {
    count = Math.abs(count)
    count %= 100
    if(count >= 5 && count <= 20) return five

    count %= 10
    if(count === 1) return one
    if(count >= 2 && count <= 4) return two

    return five; 
  }

  render() {
    const { num } = this.props

    return(
      <div className="postcards-counter">
        <div className="counter-text">
          Из Кузбасса с любовью {this.pluralForm(num, 'разлетелась','разлетелось','разлетелось')} уже
        </div>
        <div className="counter-number">{ num }</div>
        <div className="counter-text">{this.pluralForm(num, 'открытка','открытки','открыток')}</div>
      </div>
    )
  }
}

export default connect()(Counter)


// WEBPACK FOOTER //
// ./src/components/counter/Counter.js